import React from "react";
import { useNavigate } from "react-router-dom";

// 通用标题头
export default function LayoutHeader(props: { title: string, iconUrl?: string, linkUrl?: string}): JSX.Element {
  const navigate = useNavigate();
  // 跳转至指定页面
  const navitageTo = () => {
    navigate(props.linkUrl || '');
  }
  return <div className="layout-header-title">
    <h1>{ props.title }</h1>
    {/* 标题栏右侧图标 */}
    {props.iconUrl ? 
    <div className="layout-header-icon" onClick={navitageTo}>
      <img src={props.iconUrl} alt="" />
    </div> : null
    }
  </div>
}
